var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSyncedLightningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3597 2.70613C11.418 2.58786 11.3479 2.44649 11.2185 2.42133L7.70655 1.73868C7.61451 1.72079 7.5224 1.76924 7.48499 1.85522L4.75828 8.12271C4.70978 8.23419 4.77113 8.36279 4.88829 8.39524L6.64586 8.88197C6.74648 8.90984 6.80873 9.0104 6.78881 9.11288L5.91958 13.5847C5.88124 13.7819 6.12511 13.9062 6.26217 13.7592L11.975 7.63412C12.0821 7.51924 12.0211 7.33136 11.8669 7.30138L9.59278 6.85934C9.46333 6.83417 9.39323 6.69281 9.45157 6.57454L11.3597 2.70613Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncedLightningIcon);
export default __webpack_public_path__ + "static/media/synced-lightning-icon.9e93b9dfa6c628f6dc7e8de89a39d3f4.svg";
export { ForwardRef as ReactComponent };